const catalogoDigital = () =>
  import(
    /* webpackChunkName: "catalogo-digital" */ "@/modules/CatalogoDigital/pages/Index.vue"
  );

export default [
  {
    name: "catalogoDigital",
    path: "/catalogo-digital",
    component: catalogoDigital,
    meta: {
      title: "Catálogo Digital",
      permission: "catalogo-digital",
    },
  },
];
